export default {
    LOAD_DATA: "LOAD_DATA",
    ADD_ITEM: "ADD_ITEM",
    UPDATE_ITEM: "UPDATE_ITEM",
    REMOVE_ITEM: "REMOVE_ITEM",
    SEARCH: "SEARCH",
  };
  